import client from '../../base-api';

const moduleURL = '/course-private-coaching-module';
const moduleGoalURL = '/course-private-coaching-module-goal';
const randomModuleGoalURL = '/course-private-coaching-random-goal';

const coursePrivateCoachingModuleService = {

    // MODULES API
    getModules(filterData: any) {
        return client.get(`${moduleURL}`, {params: filterData});
    },
    getNextOrderNumber() {
        return client.get(`${moduleURL}/next/order-number`);
    },
    getModule(moduleId: number) {
        return client.get(`${moduleURL}/${moduleId}`);
    },
    postModule(moduleData: any) {
        return client.post(`${moduleURL}`, moduleData);
    },
    putModule(moduleData: any, moduleId: number) {
        return client.put(`${moduleURL}/${moduleId}`, moduleData);
    },
    deleteModule(moduleData: number) {
        return client.delete(`${moduleURL}/delete/${moduleData}`);
    },
    countGoals(moduleId: number) {
        return client.get(`${moduleURL}/count-goals/${moduleId}`);
    },


    // MODULE GOALS API
    getModuleGoals(moduleId: number) {
        return client.get(`${moduleGoalURL}/${moduleId}`);
    },
    goalChangePosition(data: any) {
        return client.post(`${moduleGoalURL}/change-position`, data)
    },
    postModuleGoal(goalData: any) {
        return client.post(`${moduleGoalURL}`, goalData);
    },
    putModuleGoal(goalData: any, goalId: number) {
        return client.put(`${moduleGoalURL}/${goalId}`, goalData);
    },
    getModuleGoal(goalId: number) {
        return client.get(`${moduleGoalURL}/details/${goalId}`);
    },
    deleteModuleGoal(goalId: number) {
        return client.delete(`${moduleGoalURL}/delete/${goalId}`);
    },


    // RANDOM MODULE GOAL
    getRandomModuleGoals() {
        return client.get(`${randomModuleGoalURL}`);
    },
    postRandomModuleGoal(goalData: any) {
        return client.post(`${randomModuleGoalURL}`, goalData);
    },
    putRandomModuleGoal(goalData: any, goalId: number) {
        return client.put(`${randomModuleGoalURL}/${goalId}`, goalData);
    },
    getRandomModuleGoal(goalId: number) {
        return client.get(`${randomModuleGoalURL}/details/${goalId}`);
    },
    deleteRandomModuleGoal(goalId: number) {
        return client.delete(`${randomModuleGoalURL}/${goalId}`);
    },

}

export default coursePrivateCoachingModuleService;